import React, { useState } from 'react'
import { Button, Dropdown, Menu, Space, Avatar } from 'antd'
import { GlobalOutlined, UserOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useAuth } from '../contexts/AuthContext'
import { useNavigate } from 'react-router-dom'

interface PageControlsProps {
  showUserProfile?: boolean
  onUserProfileClick?: () => void
}

const PageControls: React.FC<PageControlsProps> = ({
  showUserProfile = true,
  onUserProfileClick
}) => {
  const { i18n } = useTranslation()
  const { user, userProfile } = useAuth()
  const navigate = useNavigate()
  const [isLanguageHovered, setIsLanguageHovered] = useState(false)
  const [isUserHovered, setIsUserHovered] = useState(false)

  // Language options for the language selector
  const languageOptions = [
    { code: 'en-GB', label: 'English (GB)' },
    { code: 'en-US', label: 'English (US)' },
    { code: 'de', label: 'Deutsch' },
    { code: 'fr', label: 'Français' },
    { code: 'it', label: 'Italiano' },
    { code: 'es', label: 'Español' },
  ]

  const handleUserProfileClick = () => {
    if (onUserProfileClick) {
      onUserProfileClick()
    } else if (user) {
      // Default behavior - could open a modal or navigate
    } else {
      navigate('/auth')
    }
  }

  return (
    <Space wrap={false} style={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: 12 }}>
      {/* Language Selector */}
      <span
        onMouseEnter={() => setIsLanguageHovered(true)}
        onMouseLeave={() => setIsLanguageHovered(false)}
        style={{ display: 'inline-block' }}
      >
        <Dropdown
          overlay={
            <Menu>
              {languageOptions.map(opt => (
                <Menu.Item
                  key={opt.code}
                  onClick={() => i18n.changeLanguage(opt.code)}
                  style={{
                    backgroundColor: i18n.resolvedLanguage === opt.code ? '#279063' : 'transparent',
                    color: i18n.resolvedLanguage === opt.code ? 'white' : 'inherit',
                    fontWeight: i18n.resolvedLanguage === opt.code ? 'bold' : 'normal'
                  }}
                >
                  {opt.label}
                </Menu.Item>
              ))}
            </Menu>
          }
          trigger={['click']}
        >
          <Button
            type="text"
            size="small"
            icon={<GlobalOutlined style={{ fontSize: 20, marginRight: '4px', marginTop: 2 }} />}
            style={{
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              transform: isLanguageHovered ? 'scale(1.05)' : 'scale(1)'
            }}
          >
            {i18n.resolvedLanguage === 'en-US' ? 'EN' :
              i18n.resolvedLanguage === 'en-GB' ? 'GB' :
                i18n.resolvedLanguage?.toUpperCase()}
          </Button>
        </Dropdown>
      </span>

      {/* User Profile */}
      {showUserProfile && (
        user ? (
          <span
            onMouseEnter={() => setIsUserHovered(true)}
            onMouseLeave={() => setIsUserHovered(false)}
            onClick={handleUserProfileClick}
            style={{ display: 'inline-block' }}
          >
            <Button
              type="text"
              size="small"
              icon={
                <Avatar 
                  // size="small"
                  src={userProfile?.avatar} 
                  icon={<UserOutlined />}
                  style={{ marginRight: 0, backgroundColor: '#f0f0f000', color: '#000' }}
                />
              }
              style={{
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                transform: isUserHovered ? 'scale(1.05)' : 'scale(1)',
                padding: '4px 8px'
              }}
            >
              {userProfile?.displayName || user.displayName || user.email}
            </Button>
          </span>
        ) : (
          <span
            onMouseEnter={() => setIsUserHovered(true)}
            onMouseLeave={() => setIsUserHovered(false)}
            onClick={handleUserProfileClick}
            style={{ display: 'inline-block' }}
          >
            <Button
              type="text"
              size="small"
              icon={<UserOutlined />}
              style={{
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                transform: isUserHovered ? 'scale(1.05)' : 'scale(1)'
              }}
            >
              Login / Register
            </Button>
          </span>
        )
      )}
    </Space>
  )
}

export default PageControls